const dimensionX = 'x' as const
const dimensionY = 'y' as const
const dimensionZ = 'z' as const

const printedcircuitboardThickness = {
  options: [0.5 as const, 0.8 as const, 1.0 as const, 1.2 as const, 1.55 as const, 2.0 as const, 2.4 as const], //prettier-ignore
  value: 1.55,
  min: 0.5,
  max: 2.4,
  dimension: dimensionY
}
const printedcircuitboardComponentSide = {
  border: { top: { value: 3 }, bottom: { value: 3 }, left: { value: 0 }, right: { value: 0 } },
  height: { min: 0, value: 32, dimension: dimensionY }
}
const printedcircuitboardSolderSide = {
  border: { top: { value: 3 }, bottom: { value: 3 }, left: { value: 0 }, right: { value: 0 } },
  height: { min: 0, value: 10, dimension: dimensionY }
}
/** CONTENTEDGE */
const contentEdgeGapFront = { min: 0, value: 1, dimension: dimensionZ }
const contentEdgeGapTop = { min: 2, value: 2, dimension: dimensionY }
const contentEdgeGapRight = { min: 2, max: 8, value: 7, dimension: dimensionX }
const contentEdgeGapBottom = { min: 4, value: 4, dimension: dimensionY }
const contentEdgeGapLeft = { min: 2, max: 8, value: 7, dimension: dimensionX }
const contentEdgeGapBack = { min: 0, value: 1, dimension: dimensionZ }

// goes to total store
const contentX = { min: 100, max: 240 }
const contentY = {
  min:
    contentEdgeGapTop.min +
    contentEdgeGapBottom.min +
    printedcircuitboardThickness.min +
    printedcircuitboardComponentSide.height.min +
    printedcircuitboardSolderSide.height.min,
  max: 200
}
const contentZ = { min: 100, max: 280 }

const printedcircuitboardWidth = { value: 160, min: contentZ.min, dimension: dimensionZ }
const printedcircuitboardLength = {
  value: 100,
  min: contentX.min - contentEdgeGapLeft.min - contentEdgeGapRight.min,
  max: contentX.max - contentEdgeGapLeft.min - contentEdgeGapRight.min,
  dimension: dimensionX
}

export const contentLimits = {
  [dimensionX]: contentX,
  [dimensionY]: contentY,
  [dimensionZ]: contentZ
}
export const printedcircuitboardParameters = {
  properties: {
    width: printedcircuitboardWidth,
    length: printedcircuitboardLength,
    thickness: printedcircuitboardThickness,
    componentSide: printedcircuitboardComponentSide,
    solderSide: printedcircuitboardSolderSide
  }
}
export const contentEdgeParameters = {
  properties: {
    gap: {
      front: contentEdgeGapFront,
      top: contentEdgeGapTop,
      right: contentEdgeGapRight,
      bottom: contentEdgeGapBottom,
      left: contentEdgeGapLeft,
      back: contentEdgeGapBack
    }
  }
}

export const adapterFillHole = 5
export const adapterGlueHole = 3
export const adapterHolesDistance = 3

export const adapterPlateThicknessInside = 3
export const adapterPlateThicknessOutside = 5
//   adapterHeadCornerPositionWidth: 0,
//   adapterHeadWidth: 15, // 10
//   cornerGap: 2,
//   distanceA: 2,
//   distanceB: 2.5,
//   bracketSlotWidth: 5,
//   distanceC: 5,
//   adapterHeadSlotWidth: 17,
//   adapterProfileShift: 2,
//   adapterSquareGlue: 0,
//   nutEdgeLength: 8,
//   nutThickness: 1.5
// }

export const adapterInnerDistance = 2
export const adapterHeadNutSlotDistance = 2
export const adapterHeadNutSlotWidth = 15
export const adaoterHeadDistanceNutSlotBracketSlot = 2.5
export const adapterHeadBracketSlotWidth = 5
export const adapterHeadBracketSlotDistance = 5

/** includes the start distance of the corner */
export const adapterHeadCornerModuleWidth =
  adapterInnerDistance +
  adapterHeadNutSlotDistance +
  adapterHeadNutSlotWidth +
  adaoterHeadDistanceNutSlotBracketSlot +
  adapterHeadBracketSlotWidth +
  adapterHeadBracketSlotDistance

export const adapterHeadMiddleSlotWidth =
  adapterHeadNutSlotWidth +
  2 *
    (adaoterHeadDistanceNutSlotBracketSlot +
      adapterHeadBracketSlotWidth +
      adapterHeadBracketSlotDistance)

export const distanceTolerance = 40

export type Path = Vector2[]
export type Vector2 = [/** x */ number, /** y */ number]

export const adapterHeadNutSlotPathInside: Path = [
  [0, 0],
  [0, -2],
  [4, -2],
  [4, -0.3],
  [2.625, -0.3],
  [2.625, 2.7],
  [4, 2.7],
  [4, 4.4],
  [5.5, 4.4],
  [5.5, 6.2],
  [9.5, 6.2],
  [9.5, 4.4],
  [11, 4.4],
  [11, 2.7],
  [12.375, 2.7],
  [12.375, -0.3],
  [11, -0.3],
  [11, -2],
  [15, -2],
  [15, 0]
]

export const adapterHeadNutSlotPathOutside: Path = [
  [0, 0],
  [0, -2],
  [4, -2],
  [4, -0.3],
  [2.625, -0.3],
  [2.625, 2.7],
  [4, 2.7],
  [4, 4.4],
  [11, 4.4],
  [11, 2.7],
  [12.375, 2.7],
  [12.375, -0.3],
  [11, -0.3],
  [11, -2],
  [15, -2],
  [15, 0]
]

export const bracketThickness = 5
export const bracketInsert = 10
export const bracketInsertNeck = 5

export const adapterHeadBracketSlotPathInside: Path = [
  [0, 0],
  [0, bracketInsert - adapterInnerDistance],
  [bracketThickness, bracketInsert - adapterInnerDistance],
  [bracketThickness, 0]
]

export const adapterHeadBracketSlotPathOutside: Path = [
  [0, 0],
  [0, bracketInsertNeck - adapterInnerDistance],
  [bracketThickness, bracketInsertNeck - adapterInnerDistance],
  [bracketThickness, 0]
]
